import { createApp } from 'vue'
import i18n from "@/i18n";
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import '@/styles/global.less'
import '@/assets/font/font.less';

const pinia = createPinia()
createApp(App).use(pinia).use(router).use(i18n).mount('#app')
